module.exports = __webpack_public_path__ + "img/w_mis.48f077af.png";